// trackActions.js
import {
  FETCH_IN_PROGRESS_REQUESTS_REQUEST,
  FETCH_IN_PROGRESS_REQUESTS_SUCCESS,
  FETCH_IN_PROGRESS_REQUESTS_FAILURE,
  FETCH_COMPLETED_REQUESTS_REQUEST,
  FETCH_COMPLETED_REQUESTS_SUCCESS,
  FETCH_COMPLETED_REQUESTS_FAILURE,
  FETCH_QUERIED_REQUESTS_REQUEST,
  FETCH_QUERIED_REQUESTS_SUCCESS,
  FETCH_QUERIED_REQUESTS_FAILURE,
  FETCH_REJECTED_REQUESTS_REQUEST,
  FETCH_REJECTED_REQUESTS_SUCCESS,
  FETCH_REJECTED_REQUESTS_FAILURE,
} from './trackActionTypes';

export const fetchInProgressRequests = (userId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_IN_PROGRESS_REQUESTS_REQUEST });

    try {
      const accessToken = localStorage.getItem('accessToken'); // Get the access token

      if (!accessToken) {
        throw new Error("No access token found. Please log in.");
      }

      const response = await fetch(`http://localhost:5081/RequestSetting/inprogress/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`, // Include the access token
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched in-progress requests:", data); // Debugging: Log the fetched data
      dispatch({ type: FETCH_IN_PROGRESS_REQUESTS_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error fetching in-progress requests:", error); // Debugging: Log the error
      dispatch({ type: FETCH_IN_PROGRESS_REQUESTS_FAILURE, payload: error.message });
    }
  };
};



export const fetchCompletedRequests = (userId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_COMPLETED_REQUESTS_REQUEST });

    try {
      const accessToken = localStorage.getItem('accessToken'); // Get the access token

      if (!accessToken) {
        throw new Error("No access token found. Please log in.");
      }

      const response = await fetch(`http://localhost:5081/RequestSetting/completed/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`, // Include the access token
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched completed requests:", data); // Debugging: Log the fetched data
      dispatch({ type: FETCH_COMPLETED_REQUESTS_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error fetching completed requests:", error); // Debugging: Log the error
      dispatch({ type: FETCH_COMPLETED_REQUESTS_FAILURE, payload: error.message });
    }
  };
};


export const fetchQueriedRequests = (userId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_QUERIED_REQUESTS_REQUEST });

    try {
      const accessToken = localStorage.getItem('accessToken'); // Get the access token

      if (!accessToken) {
        throw new Error("No access token found. Please log in.");
      }

      const response = await fetch(`http://localhost:5081/RequestSetting/queried/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`, // Include the access token
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched queried requests:", data); // Debugging: Log the fetched data
      dispatch({ type: FETCH_QUERIED_REQUESTS_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error fetching queried requests:", error); // Debugging: Log the error
      dispatch({ type: FETCH_QUERIED_REQUESTS_FAILURE, payload: error.message });
    }
  };
};



export const fetchRejectedRequests = (userId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_REJECTED_REQUESTS_REQUEST });

    try {
      const accessToken = localStorage.getItem('accessToken'); // Get the access token

      if (!accessToken) {
        throw new Error("No access token found. Please log in.");
      }

      const response = await fetch(`http://localhost:5081/RequestSetting/rejected/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`, // Include the access token
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched rejected requests:", data); // Debugging: Log the fetched data
      dispatch({ type: FETCH_REJECTED_REQUESTS_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error fetching rejected requests:", error); // Debugging: Log the error
      dispatch({ type: FETCH_REJECTED_REQUESTS_FAILURE, payload: error.message });
    }
  };
};


